import { c as _c } from "react/compiler-runtime";
import { trackNavigationHeaderClick } from '../../../../../../shared';
import type { VisualItem } from '../../../../../../types';
import { BrandCard } from '../../../../shared';
import './visual-items-grid.scss';
type VisualItemsGridProps = {
  items: VisualItem[];
  onLinkSelect: () => void;
  selectionPath: string[];
};

// Only the `imageOnly` layout (e.g. Brands) renders as an image grid on mobile; other visual
// layouts are flattened into a plain text link list by `nested-level.utils.ts` instead.
export function VisualItemsGrid(t0) {
  const $ = _c(9);
  const {
    items,
    onLinkSelect,
    selectionPath
  } = t0;
  let t1;
  if ($[0] !== items || $[1] !== onLinkSelect || $[2] !== selectionPath) {
    let t2;
    if ($[4] !== onLinkSelect || $[5] !== selectionPath) {
      t2 = item => <li key={`${item.href}::${item.title ?? item.label}`} className="mobile-menu-visual-items-grid__item"><BrandCard card={{
          href: item.href,
          imageUrl: item.imageUrl,
          label: item.label,
          openInNewTab: item.openInNewTab
        }} onClick={() => {
          trackNavigationHeaderClick({
            selection: [...selectionPath, item.title ?? item.label],
            linkUrl: item.href,
            navSection: "main nav"
          });
          onLinkSelect();
        }} /></li>;
      $[4] = onLinkSelect;
      $[5] = selectionPath;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = items.map(t2);
    $[0] = items;
    $[1] = onLinkSelect;
    $[2] = selectionPath;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <ul aria-label="Navigation links" className="mobile-menu-visual-items-grid">{t1}</ul>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}